import DefaultImg from '../images/h5-self-service/defaultImg.webp';

export function FolderImage(imgUrl?: string) {
  if (imgUrl) {
    return imgUrl;
  }
  return DefaultImg;
}

export function FileImage(imgUrl?: string) {
  if (imgUrl) {
    return imgUrl;
  }
  return DefaultImg;
}
